import { getCSQGlobal } from '../services/analytics.service';
getCSQGlobal().push(["getSessionKey", {
        callback: (sessionKey) => {
            if (sessionKey) {
                const hiddenInput = document.querySelector('input[name="contact[csq_session_key]"]');
                if (hiddenInput) {
                    hiddenInput.value = sessionKey;
                }
                else {
                    console.warn('Hidden input element not found');
                }
            }
        }
    }]);
